import { TravellerDocument, TravellerType } from '@wegoTypes/traveller';

export function getPassportDoc(docs?: TravellerDocument[]): TravellerDocument | undefined {
  return docs?.find((doc) => doc.documentType === 'PASSPORT');
}

export function getNationalIdDoc(docs?: TravellerDocument[]): TravellerDocument | undefined {
  return docs?.find((doc) => doc.documentType === 'NATIONAL_ID');
}

export const getTravellerType = (dateOfBirth?: string): TravellerType => {
  if (!dateOfBirth) {
    return 'ADULT';
  }
  let day = '';
  let month = '';
  let year = '';

  if (dateOfBirth.match(/^\d{4}-\d{2}-\d{2}$/)) {
    [year, month, day] = dateOfBirth.split('-');
  }
  if (dateOfBirth.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
    [day, month, year] = dateOfBirth.split('/');
  }

  const [parsedDay, parsedMonth, parsedYear] = [Number(day), Number(month), Number(year)];

  const birthDate = new Date(parsedYear, parsedMonth - 1, parsedDay);
  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  if (age < 2) {
    return 'INFANT';
  }
  if (age < 12) {
    return 'CHILD';
  }
  return 'ADULT';
};
